module.exports = __webpack_public_path__ + "media/src/assets/Images/CarruselLeft-b6f28ebbea265e449bbbfb3e1bca2961.svg";